module.exports = __webpack_public_path__ + "static/img/4.30d3be1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mockups/screenshots/4.jpg
// module id = PXf+
// module chunks = 0